import { axios } from "..";

export type PaymentReminderRecipientOutcome = "sent" | "failed" | "skipped";

export interface IPaymentReminderLogRecipient {
  registrationId: string;
  personName: string;
  outcome: PaymentReminderRecipientOutcome;
  reason?: string;
}

export interface IPaymentReminderBatchLog {
  id?: string;
  eventId?: string | null;
  eventName?: string | null;
  triggeredAt: string;
  completedAt: string;
  triggeredById: string;
  triggeredByName: string;
  totalSelected: number;
  sentCount: number;
  failedCount: number;
  skippedCount: number;
  selectedRegistrationIds: string[];
  recipients: IPaymentReminderLogRecipient[];
}

export interface SavePaymentReminderBatchLogRequest {
  eventId?: string | null;
  eventName?: string | null;
  triggeredAt: string;
  completedAt: string;
  triggeredById: string;
  triggeredByName: string;
  totalSelected: number;
  sentCount: number;
  failedCount: number;
  skippedCount: number;
  selectedRegistrationIds: string[];
  recipients: IPaymentReminderLogRecipient[];
}

export const savePaymentReminderBatchLog = async (
  request: SavePaymentReminderBatchLogRequest,
): Promise<{ success: boolean; id?: string }> => {
  const response = await axios.Post("./payment-reminder-log", request);
  return response.data;
};

export const getPaymentReminderBatchLogs = async (options?: {
  eventId?: string;
  limit?: number;
}): Promise<IPaymentReminderBatchLog[]> => {
  const filter: Record<string, unknown> = {};
  if (options?.eventId) {
    filter.eventId = { value: options.eventId, comparisonType: "EQUAL" };
  }

  const params = new URLSearchParams();
  if (Object.keys(filter).length > 0) {
    params.append("filter", JSON.stringify(filter));
  }
  params.append(
    "sort",
    JSON.stringify({ field: "triggeredAt", order: "desc" }),
  );
  params.append(
    "pagination",
    JSON.stringify({
      pageIndex: 0,
      pageSize: options?.limit ?? 20,
    }),
  );

  const response = await axios.Get(`./payment-reminder-log?${params.toString()}`);
  return Array.isArray(response.data) ? response.data : [];
};
